import { FC, useCallback } from 'react';
import { selectSubsidizedMortgageFilter } from 'shared/selectors/advancedFilters';
import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const SubsidizedMortgageContainer: FC = () => {
  const { label, value, visible, options } = useSelectorWithConfig(selectSubsidizedMortgageFilter);

  const onChange = useFilterChangeCallback();

  const handleSubsidizedMortgageChange = useCallback(
    (newValue: boolean | null) => {
      onChange({ action: 'setIsSubsidisedMortgage', arguments: [newValue] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleSubsidizedMortgageChange} />
    </AdvancedFilterRow>
  );
};
